/** FIFA Ultimate Team Icon shield — clipPathUnits objectBoundingBox.
 *  Outer = card silhouette. Photo = same shape inset as a foil Rand,
 *  with extra room kept at the bottom tip. */
export function FifaShieldClip() {
  return (
    <svg className="fifa-shield-defs" aria-hidden width="0" height="0">
      <defs>
        <clipPath id="un8-fifa-shield" clipPathUnits="objectBoundingBox">
          <path d="M0.5 0.006 C0.455 0.006 0.405 0.028 0.37 0.04 L0.3 0.052 C0.24 0.06 0.16 0.048 0.11 0.06 L0.078 0.078 L0.055 0.12 L0.055 0.62 L0.028 0.645 L0.028 0.705 L0.055 0.73 C0.055 0.82 0.22 0.92 0.5 0.992 C0.78 0.92 0.945 0.82 0.945 0.73 L0.972 0.705 L0.972 0.645 L0.945 0.62 L0.945 0.12 L0.922 0.078 C0.88 0.06 0.8 0.06 0.7 0.052 L0.63 0.04 C0.595 0.028 0.545 0.006 0.5 0.006 Z" />
        </clipPath>
        <clipPath id="un8-fifa-shield-photo" clipPathUnits="objectBoundingBox">
          {/* Rewritten 2026-09-21 (Masco: "die Ränder etwas einheitlicher und
              nicht an manchen 0 und oben mehr").

              The old inner path was uneven BY CONSTRUCTION: 3% clear at the
              sides, only 1.6% at the top and 5% at the bottom — so the rim
              read as nothing along the top edge. Units here are the object's
              own box, and the card is 5:7, so the SAME pixel gap needs a
              smaller number vertically than horizontally (Δy = Δx / 1.4).

              Widened again on his second look — at 7 px the sides and chin
              still read as "no space". Now Δx = 0.058 at the sides and
              Δy = 0.052 at the top, tip pulled to 0.928. On a 165 × 231 card:
              about 10 px at the sides, 12 px at the top, 15 px at the chin.
              Top stays the largest, as he asked, but every edge is clearly
              there. The outer notch at the waist is dropped from the inner
              path: at this inset it collapses to nothing and only wobbles. */}
          <path d="M0.5 0.058 C0.47 0.058 0.437 0.077 0.407 0.089 L0.347 0.101 C0.292 0.108 0.212 0.101 0.164 0.113 L0.133 0.131 L0.113 0.166 L0.113 0.700 C0.113 0.778 0.268 0.866 0.5 0.928 C0.732 0.866 0.887 0.778 0.887 0.700 L0.887 0.166 L0.867 0.131 C0.836 0.113 0.756 0.108 0.653 0.101 L0.593 0.089 C0.563 0.077 0.53 0.058 0.5 0.058 Z" />
        </clipPath>
      </defs>
    </svg>
  );
}
